export const FEATURE_ANSWERS = 'FEATURE_ANSWERS';
export const FEATURE_SHUFFLE = 'FEATURE_SHUFFLE';
export const FEATURE_PREDEFINED_ANSWERS = 'FEATURE_PREDEFINED_ANSWERS';
export const FEATURE_ADD_OTHER = 'FEATURE_ADD_OTHER';
export const FEATURE_DECIMAL_LIMIT = 'FEATURE_DECIMAL_LIMIT';
export const FEATURE_ADD_LIMITS = 'FEATURE_ADD_LIMITS';
export const FEATURE_LIMIT_RANGE = 'FEATURE_LIMIT_RANGE';
export const FEATURE_NONE_OF_THE_ABOVE = 'FEATURE_NONE_OF_THE_ABOVE';
export const FEATURE_NONE_OF_THESE = 'FEATURE_NONE_OF_THESE';
export const FEATURE_BATCH_ANSWERS = 'FEATURE_BATCH_ANSWERS';
export const FEATURE_ADVANCED_LOGIC = 'FEATURE_ADVANCED_LOGIC';
export const FEATURE_DISPLAY_LOGIC = 'FEATURE_DISPLAY_LOGIC';
export const FEATURE_ADD_MEDIA = 'FEATURE_ADD_MEDIA';
export const FEATURE_RATING = 'FEATURE_RATING';
export const FEATURE_SLIDER = 'FEATURE_SLIDER';
export const FEATURE_RANKING = 'FEATURE_RANKING';
export const FEATURE_MATRIX = 'FEATURE_MATRIX';
export const FEATURE_MATRIX_BIPOLAR = 'FEATURE_MATRIX_BIPOLAR';
export const FEATURE_MATRIX_OPEN_ENDED = 'FEATURE_MATRIX_OPEN_ENDED';
export const FEATURE_MATRIX_NUMERIC_OPEN_ENDED =
  'FEATURE_MATRIX_NUMERIC_OPEN_ENDED';
export const FEATURE_MATRIX_CONSTANT_SUM = 'FEATURE_MATRIX_CONSTANT_SUM';
export const FEATURE_MATRIX_CONVERSATIONAL = 'FEATURE_MATRIX_CONVERSATIONAL';
export const FEATURE_NPS = 'FEATURE_NPS';
export const FEATURE_RECALL = 'FEATURE_RECALL';
export const FEATURE_CARRY_FORWARD = 'FEATURE_CARRY_FORWARD';
export const FEATURE_QUESTIONS = 'FEATURE_QUESTIONS';
export const FEATURE_AB_TEST = 'FEATURE_AB_TEST';
export const FEATURE_AB_SELECT_ATTRIBUTES = 'FEATURE_AB_SELECT_ATTRIBUTES';
export const FEATURE_DOE = 'FEATURE_DOE';
export const FEATURE_VAN_WESTENDORP = 'FEATURE_VAN_WESTENDORP';
export const FEATURE_VAN_WESTENDORP_QUESTION =
  'FEATURE_VAN_WESTENDORP_QUESTION';
export const FEATURE_MAXDIFF = 'FEATURE_MAXDIFF';
export const FEATURE_MAXDIFF_QUESTION = 'FEATURE_MAXDIFF_QUESTION';
export const FEATURE_DRILLDOWN_QUESTION = 'FEATURE_DRILLDOWN_QUESTION';
export const FEATURE_LIMIT_TEXT_LENGTH = 'FEATURE_LIMIT_TEXT_LENGTH';
export const MATRIX_FEATURES = {
  DECIMALS: 'DECIMALS',
  LIMIT_RANGE: 'LIMIT_RANGE',
  CUSTOM_SIGN: 'CUSTOM_SIGN',
};
export const FEATURE_QUOTAS_SCREENING = 'FEATURE_QUOTAS_SCREENING';
export const FEATURE_QUOTAS_SIMPLE = 'FEATURE_QUOTAS_SIMPLE';
export const FEATURE_MINIMUM_RESPONSES = 'FEATURE_MINIMUM_RESPONSES';
export const FEATURE_QUOTA_ASSIGNMENT = 'FEATURE_QUOTA_ASSIGNMENT';
export const FEATURE_QUOTAS_ADVANCED = 'FEATURE_QUOTAS_ADVANCED';
export const FEATURE_DISPLAY_SAME_PAGE = 'FEATURE_DISPLAY_SAME_PAGE';
export const FEATURE_LOOP_MERGE = 'FEATURE_LOOP_MERGE';
